import { Instance } from 'mobx-state-tree'
import { UserRosterModelBase } from './UserRosterModel.base'

/* The TypeScript type of an instance of UserRosterModel */
export interface UserRosterModelType extends Instance<typeof UserRosterModel.Type> {}

/* A graphql query fragment builders for UserRosterModel */
export { selectFromUserRoster, userRosterModelPrimitives, UserRosterModelSelector } from './UserRosterModel.base'

/**
 * UserRosterModel
 */
export const UserRosterModel = UserRosterModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
